export const selectCandidateTransferState = (state) => state.candidateTransfer;
